<template>
  <div
    class="tw-relative tw-flex tw-justify-center tw-items-center tw-h-screen tw-bg-gray-50 tw-p-6"
  >
    <div
      class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-z-0"
      :style="{ backgroundImage: 'url(/img/arpoone-logo-bg.svg)' }"
    ></div>

    <CCard class="tw-animate-fade-in">
      <CCardBody
        class="tw-bg-white tw-shadow-xl tw-p-10 tw-max-w-lg tw-w-full tw-text-center"
      >
        <img
          src="/img/errors/404-error.svg"
          alt="404 Error"
          class="tw-w-64 tw-mx-auto tw-mb-6 tw-transform tw-transition-transform tw-duration-700 hover:tw-scale-105"
          width="256"
          height="256"
          priority
        />

        <div class="tw-text-3xl tw-font-bold tw-mb-2 tw-text-gray-800">
          {{ $t('error.page.404.title') }}
        </div>

        <div class="tw-text-lg tw-mb-6 tw-text-gray-500 tw-italic">
          {{ $t('error.page.404.subTitle') }}
        </div>

        <NuxtLink
          :to="{ name: 'auth-login' }"
          class="tw-inline-block tw-text-blue-600 tw-font-medium tw-underline tw-transition tw-transform tw-duration-300 hover:tw-scale-105"
        >
          {{ $t('error.page.404.linkHome') }}
        </NuxtLink>
      </CCardBody>
    </CCard>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  layout: 'blank',
})
</script>
